import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import getIsCurrentRegionUserLoyaltyRegion from './getIsCurrentRegionUserLoyaltyRegion'

const getIsLoyaltyPrioritySupportNumberEnabled = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => state.loyalty.account,
  (state: App.State) => state.geo.contacts.loyalty,
  (isLoyaltyEnabled, isInLoyaltyRegion, account, loyaltyContact) => {
    if (!isInLoyaltyRegion) return false

    const accountBenefits = account?.data?.benefits
    const hasPrioritySupportBenefit = !!accountBenefits?.find((benefit) => benefit.code === 'phone_support')
    const hasPrioritySupportNumber = !!loyaltyContact?.defaultContact.number
    return hasPrioritySupportBenefit && hasPrioritySupportNumber
  },
)

export default getIsLoyaltyPrioritySupportNumberEnabled
